import useExperiment from 'hooks/common/use-experiment';

interface UseTest9403Return {
  isEntryTeaser: boolean;
  isDataNeedCaptureHeader: boolean;
  isFloatingButtonFeatureEnabled: boolean;
  loading: boolean;
}

/** A/B/C variant flags for the Picky Cats engagement entry points: V1 teaser, V2 USP card, V3 floating button. */
const useTest9403 = (): UseTest9403Return => {
  const { variant, loading } = useExperiment({
    baseEntryId: '1jzHxoHOLw3DvCXgu5Rc4d',
  });

  return {
    isEntryTeaser: variant === 0,
    isDataNeedCaptureHeader: variant === 1,
    isFloatingButtonFeatureEnabled: variant === 2,
    loading,
  };
};

export default useTest9403;
